import { alpha, makeStyles } from '@material-ui/core';
import commonStyles from 'config/commonStyles';
import { theme } from 'config/theme';

export const useStyles = makeStyles({
    ...commonStyles,
    root: {
        minHeight: '100%',
        width: '100%',
    },
    tableCellHeader: {
        fontSize: '14px',
        fontWeight: '400',
        color: alpha(theme.palette.common.black, 0.6),
    },
    tableCellHeaderContainer: {
        marginBottom: 0,
        marginTop: 3,
    },
    iconButton: {
        color: theme.palette.common.black,
    },
    enrollmentHint: {
        fontSize: 12,
        fontStyle: 'italic',
        color: alpha(theme.palette.common.black, 0.6),
        lineHeight: 1.4,
        padding: '16px 16px 0',
        marginBottom: 10,
    },
    tokenPanel: {
        padding: 16,
        marginBottom: 16,
    },
    tokenRow: {
        display: 'flex',
        alignItems: 'flex-start',
        '& button': {
            marginLeft: 15,
        },
    },
    tokenInput: {
        width: 420,
    },
    monospace: {
        fontFamily: 'monospace',
    },
    warning: {
        color: theme.palette.error.main,
    },
});
